import React from 'react'
import { object, string, func, bool, node } from 'prop-types'
import classnames from 'classnames'

const Input = ({
  onChange,
  type = 'text',
  value = '',
  label,
  labelDirection,
  name,
  innerLabelHTML = false,
  inputProps
}) => {
  const classes = classnames({
    'ad-input': true,
    'ad-input--label-up': labelDirection === 'up',
    'ad-input--label-down': labelDirection === 'down',
    'ad-input--label-right': labelDirection === 'right'
  })
  let labelComponent
  if (label) {
    if (!innerLabelHTML) {
      labelComponent = <label htmlFor={name} >{label}</label>
    } else {
      labelComponent = <label htmlFor={name} dangerouslySetInnerHTML={{ __html: label }} />
    }
  }
  return (
    <div className={classes}>
      {labelComponent}
      <input type={type} name={name} onChange={onChange} value={value} {...inputProps} />
    </div>
  )
}

Input.propTypes = {
  type: string,
  value: node,
  label: string,
  labelDirection: string,
  name: string,
  onChange: func,
  inputProps: object,
  innerLabelHTML: bool
}

export default Input